import { SubscriptionInterval } from '@platform-frontend/checkout-drop-in';

export type ExtendedSubscriptionInterval = 'DAILY' | 'WEEKLY' | SubscriptionInterval;
